import { createContext } from 'react';
import { NameFormat, OptionsDisplay, RefreshTimes, SDKOptions, ShortNameType, Themes, WidgetType } from '../../../types';

export interface ConfigContextType {
  dataWidgetId?: string;
  dataWidgetSport?: string;
  dataWidgetType?: WidgetType;
  dataBettingBrandColors?: boolean;
  dataBettingLogoClickAction?: boolean;
  dataBettingLogoOverlap?: boolean;
  dataOddsClickable?: boolean;
  dataLabels?: Record<string, string | undefined> | null;
  dataOddsPreEventOnly?: boolean;
  dataRefreshTime?: RefreshTimes;
  dataTheme?: Themes | null;
  sdkOptions?: SDKOptions;
  dataOptionsDisplay?: OptionsDisplay;
  dataBettingLogoDisplay?: boolean;
  dataOddsDisplay?: boolean;
  dataOddsBettingId?: string | null;
  dataAgeRestrictionDisplay?: string;
  dataShowCompetitionNames?: boolean;
  dataAllowInlineOdds?: boolean;
  dataNameFormat?: NameFormat;
  dataTeamNameType?: ShortNameType | string | null; // used by all sports... this should be undefined or string when fix all sports types
  dataImageDisplay?: boolean;
  dataHighlightEntities?: string[];
}

export const ConfigContext = createContext<ConfigContextType>({});
